import { FormDependiente } from './helpers/components/formDependientes';

export function CollapseFormDependiente({
  handleSubmit = () => null,
  isPasoEmision = false,
  formData = {}
}) {
  return (
    <FormDependiente
      handleSubmit={handleSubmit}
      isPasoEmision={isPasoEmision}
      formData={formData}
    />
  );
}
